import { useSelector } from 'react-redux'
import { UseI18n } from '../../../common/hooks/useI18n'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'
import { formatText, formatVal, isInValidValue } from '../../../helpers/value'
import { EMPTY_VALUE } from '../../../utils/common'
import { HighlightInformation } from '../../common/header/highlightInformation'
import { HIGHLIGHT_KEYS, PANEL_ID } from '../constant'
import { selectCompanyHighlight } from '../store/slice'

export const Highlight = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectCompanyHighlight())

  const yearsText = UseI18n('companyProfile.YEARS')
  const yearText = UseI18n('companyProfile.YEAR')

  const { formatCurrencyWithUnit } = useFormatCurrency(SCREEN.COMPANY_PROFILE)

  const formatDetailData = ({ data, highlightKey }) => {
    const detailData = data[HIGHLIGHT_KEYS[highlightKey]]
    if (isInValidValue(detailData)) return EMPTY_VALUE

    switch (HIGHLIGHT_KEYS[highlightKey]) {
      case HIGHLIGHT_KEYS.YEARS_OF_OPERATION:
        return (
          formatVal(detailData, locale, false, 0) +
          ' ' +
          (detailData <= 1 ? yearText : yearsText).toUpperCase()
        )
      case HIGHLIGHT_KEYS.NUMBER_OF_EMPLOYEES:
        return formatVal(detailData, locale, false, 0)
      case HIGHLIGHT_KEYS.LISTING_STATUS:
        return detailData
      case HIGHLIGHT_KEYS.CHARTER_CAPITAL:
        return formatCurrencyWithUnit({ value: detailData })
      default:
        return formatText(detailData)
    }
  }

  const highlights = Object.keys(HIGHLIGHT_KEYS).map((key) => {
    return {
      title: UseI18n('companyProfile.' + key),
      detail: formatDetailData({ data, highlightKey: key }),
      scrollElementId: PANEL_ID.OVERVIEW,
    }
  })

  return <HighlightInformation highlights={highlights} />
}
